/**
 * Omskriver lokal appserver-URL til dev-server proxy (ServicePro nx serve / Umbraco Startup).
 * http://localhost:20081/pk-test/ -> /appserver/pk-test/
 */
export function convertAppserverUrlToLocalProxy(appServerUrl: string): string {
    const isLocalhost =
        typeof window !== "undefined" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

    if (!isLocalhost || !appServerUrl) {
        return appServerUrl;
    }

    const localhostPattern = /^https?:\/\/(localhost|127\.0\.0\.1):20081\/(.*)$/i;
    const match = appServerUrl.match(localhostPattern);

    if (match) {
        return `/appserver/${match[2]}`;
    }

    return appServerUrl;
}
